<template>
  <el-dialog
    title="Verify Mobile"
    :visible.sync="modalvisible"
    width="25%"
    :close-on-click-modal="false"
    @close="handleClose"
    @closed="handleClose"

  >
    <div class="roombox">
      <div v-loading="loading" element-loading-text="Submit...">
        <div class="itembox1" v-if="!writerable">

          <span style="width: 90px">phone：</span> <span>{{ phone }}</span
        ><i
          class="el-icon-edit el-input__icon"
          slot="suffix"
          @click="writerable = true"
        >
        </i>
        </div>
        <div class="itembox" v-if="writerable">

      <span style="width: 90px">phone：</span
      >
          <el-select class="base-input" style="width: 95px; margin-right: 10px" v-model="telTypeValue" placeholder="请选择区号">
            <el-option
              v-for="item in telType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            class="inpt"
            style="width: 210px"
            v-model="phone"
            type="number"
            focus="true"
            placeholder="content"
          ></el-input
          ><el-button type="primary" style="background:#007AB0" @click="changephonenum">Confirm</el-button>
        </div>
        <div class="yzmbox">
          <el-input
            class="inpt"
            v-model="vercode"
          >
            <el-button v-if="!getsmsing" type="text" slot="suffix" style="height:39px;background:none;" @click="getsms"><span v-if="!hadgetsms">OTP</span><span v-if="hadgetsms">Resent</span></el-button>
            <el-button v-if="getsmsing" type="text" slot="suffix" style="height:39px;background:none;">{{ dtime }}s</el-button>
          </el-input
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button class="submitbtn" type="primary" v-if="!buttonFlag" style="background:#007AB0" @click.stop="okclick">Confirm and Submit</el-button>
        <el-button class="submitbtn" type="primary" v-else style="background:#999999">Confirm and Submit</el-button>
    </span>
      <div style="color:red;font-size:12px;margin-top:10px" v-if="!passcheck">Wrong OTP</div>
    </div>
  </el-dialog>
</template>

<script>
  import { getchecksms } from "@/api/search"
  import $ from "jquery";
  export default {
    name: "CheckPhone",
    props: ["visibles", "phonenum", "code", "passcheck"],
    data() {
      return {
        writerable: false,
        phone: '',
        getsmsing:false,
        dtime:60,
        hadgetsms:false,
        changetime:"",
        checkphonesuccess:false,
        vercode:"",
        buttonFlag: false,
        telType: [
          {
            value: "+65",
            label: "+65"
          },
          {
            value: "+60",
            label: "+60"
          },
          {
            value: "+86",
            label: "+86"
          },
          {
            value: "+1",
            label: "+1"
          },
          {
            value: "+91",
            label: "+91"
          },
          {
            value: "+95",
            label: "+95"
          },
          {
            value: "+66",
            label: "+66"
          },
          {
            value: "+62",
            label: "+62"
          },
          {
            value: "+852",
            label: "+852"
          },
          {
            value: "+853",
            label: "+853"
          },
          {
            value: "+886",
            label: "+886"
          }
        ],
        telTypeValue: '+65',
        loading: false
      };
    },
    methods: {
      handleClose() {
        this.$emit('handlemodal')
      },
      changephonenum () {
        // if (this.telTypeValue === '+65' && !/^\d{8}$/.test(this.phone)) {
        //   this.$message.error('Wrong Mobile Number format!')
        //   return false
        // }
        // if (this.telTypeValue === '+86' && !/^1[3456789]\d{9}$/.test(this.phone)) {
        //   this.$message.error('Wrong Mobile Number format!')
        //   return false
        // }
        // if(!(/^1[3-9][0-9]{9}$/.test(this.phone))){
        //     this.$message.error('请输入正确格式的手机号')
        //     return
        //  }
        this.writerable = false
      },
      okclick() {
        if (this.vercode === '') {
          this.$message.warning("Please enter the verification code")
          return false
        }
        this.loading = true
        this.buttonFlag = true
        this.$emit('checkphonesubmit',this.phone)
      },
      submitFlag (flag) {
        this.loading = false
        this.buttonFlag = false
        if (flag === 'error') {
          this.$message.warning('Submit failed, please resubmit!')
        }
      },
      async submitp(){
        let phone = this.phone
        const response = await getchecksms(phone, this.telTypeValue)
        if(response&&response.code&&response.code === '10000'){
          console.log(response.msg)
        }else {
          this.$message.error(response.msg)
        }
      },
      changewriterable() {},
      getsms(){
        this.dtime = 60
        this.getsmsing = true
        this.changetime = setInterval(()=>{
          this.dtime--
          if(this.dtime === 0){
            this.getsmsing = false
            this.hadgetsms = true
            clearInterval(this.changetime)
          }
        },1000)
        this.submitp()
      }
    },
    computed:{
      modalvisible(){
        return this.visibles
      }
    },
    watch: {
      visibles(val) {
        if (val) {
          this.phone = this.phonenum;
          this.telTypeValue = this.code
        }
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .roombox
    width 100%
    height 100%
    padding 5px
    .itembox1
      width 100%
      display flex
      justify-content flex-start
      align-items center
      margin-bottom 20px
      font-size 16px
      span
        margin-right 10px
    .itembox
      width 100%
      display flex
      justify-content space-between
      align-items center
      font-size 16px
      margin-bottom 20px
      .inpt
        width 230px
    .yzmbox
      width 100%
      margin-bottom 20px
      .inpt
        width 100%
    .dialog-footer
      width 100%
      margin-top 10px
      .submitbtn
        width 100%
</style>




// WEBPACK FOOTER //
// src/components/modal/check-phone.vue